import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  formControl: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#006BD7'
    },
    marginLeft: '0px!important',
    '& .MuiInputLabel-root': {
      backgroundColor: '#ffffff',
      padding: '0 4px',
      '&.MuiInputLabel-shrink': {
        backgroundColor: '#ffffff',
      }
    }
  },
  dropdownSelect: {
    // Add any specific styles for the select
  },
  dropdownItems: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: 'none'
  },
  titleField: {
    marginTop: '24px !important',
    '@media (min-width: 600px)': {
      width: 'calc(100% + 0.65rem)',
      marginLeft: '-0.65rem !important'
    },
    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      borderColor: '#006BD7'
    },
    '& fieldset': {
      borderRadius: '8px'
    }
  }
});
